import useAmplitude from '@eversports/amplitude-react/useAmplitude'
import Box from '@eversports/klimt-primitives/legacy/Box'
import Icon from '@eversports/klimt-primitives/legacy/Icon'
import Stack from '@eversports/klimt-primitives/legacy/Stack'
import Text from '@eversports/klimt-primitives/legacy/Text'
import { useState } from 'react'

import SearchIcon from '../../../../../../assets/icons/search.svg'
import { Localized } from '../../../../../../localization/react'
import SubSectionCard from '../../components/SubSectionCard'

import Search from './Search'

const SearchUsers = () => {
  const { amplitude } = useAmplitude()
  const [isModalOpen, setIsModalOpen] = useState(false)

  const toggleDialog = () => {
    setIsModalOpen(!isModalOpen)
  }

  const handleClick = () => {
    toggleDialog()
    if (amplitude) {
      amplitude.logEvent('Clicked User Search Bar')
    }
  }

  return (
    <>
      <SubSectionCard onClick={handleClick}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Stack>
            <Text sx={{ color: 'midnight', fontWeight: 'bold' }}>
              <Localized id="search-friends-title" />
            </Text>
            <Text variant="small">
              <Localized id="search-friends-sub-title" />
            </Text>
          </Stack>
          <Box sx={{ padding: 2, backgroundColor: 'lightgray', borderRadius: 1 }}>
            <Icon src={SearchIcon} size="default" color="carbon" />
          </Box>
        </Stack>
      </SubSectionCard>
      <Search isOpen={isModalOpen} toggleDialog={toggleDialog} />
    </>
  )
}

export default SearchUsers
